var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconYoutube = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 34,
  height: 25,
  viewBox: "0 0 34 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M2.30002 20.1347C1.23333 15.1008 1.23333 9.89919 2.30002 4.86525C2.44017 4.35405 2.71098 3.88812 3.08579 3.5133C3.46061 3.13849 3.92654 2.86768 4.43774 2.72753C12.6274 1.37077 20.9846 1.37077 29.1743 2.72753C29.6855 2.86768 30.1514 3.13849 30.5262 3.5133C30.901 3.88812 31.1718 4.35405 31.312 4.86525C32.3787 9.89919 32.3787 15.1008 31.312 20.1347C31.1718 20.6459 30.901 21.1119 30.5262 21.4867C30.1514 21.8615 29.6855 22.1323 29.1743 22.2724C20.9846 23.6295 12.6274 23.6295 4.43774 22.2724C3.92654 22.1323 3.46061 21.8615 3.08579 21.4867C2.71098 21.1119 2.44017 20.6459 2.30002 20.1347Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.7522 17.0809L21.3869 12.5L13.7522 7.91919V17.0809Z",
  stroke: "white",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export default SvgIconYoutube;